export default __webpack_public_path__ + "fonts/CiscoSansExtraLight-webfont.eot";